export class AudienceWifiStats {

    private connections: number;
    private newConnections: number;
    private returned: number;
    private users: number;

    constructor(connections?: number,
                newConnections?: number,
                returned?: number,
                users?: number) {
                    this.connections = connections;
                    this.newConnections = newConnections;
                    this.returned = returned;
                    this.users = users;
        }

    public get Connections(): number {
        return this.connections;
    }
    public get NewConnections(): number {
        return this.newConnections;
    }
    public get Returned(): number {
        return this.returned;
    }
    public get Users(): number {
        return this.users;
    }



    public set Connections(connections: number) {
        this.connections = connections;
    }
    public set NewConnections(newConnections: number) {
        this.newConnections = newConnections;
    }
    public set Returned(returned: number) {
        this.returned = returned;
    }
    public set Users(users: number) {
        this.users = users;
    }

}
